import React from 'react';
import Slider from '@mui/material/Slider';

const SliderField = ({
	// ...existing props...
	value, 
	onChange, 
	min = 0, 
	max = 100, 
	step = 1, 
	marks = [],
	primarycolor,
	...props
}) => {
	const handleSliderChange = (event, newValue) => {
		if (onChange) {
			onChange(newValue);
		}
	};

	// Compute numeric slider value: use passed value if valid, otherwise fallback to default or min.
	const sliderValue = !isNaN(Number(value)) && value !== "" ? Number(value) : (props.default !== undefined ? props.default : min);

	return (
		<Slider
			value={sliderValue}
			onChange={handleSliderChange}
			aria-labelledby="slider"
			valueLabelDisplay="auto"
			valueLabelFormat={props.valueSuffix ? ((value) => `${value}${props.valueSuffix}`) : undefined} // conditionally add suffix
			min={min}
			max={max}
			step={step}
			marks={marks}
			sx={
				primarycolor
					? {
							color: primarycolor,
							'& .MuiSlider-track': { border: 'none', height: 6 },
							'& .MuiSlider-rail': { opacity: 0.5, backgroundColor: '#bfbfbf', height: 6 },
							'& .MuiSlider-thumb': { height: 16, width: 16 }
					  }
					: {
							'& .MuiSlider-track': { border: 'none', height: 6 },
							'& .MuiSlider-rail': { opacity: 0.5, backgroundColor: '#bfbfbf', height: 6 },
							'& .MuiSlider-thumb': { height: 16, width: 16 }
					  }
			}
			{...props}
		/>
	);
};

export default SliderField;
